// LocaleModule state is in separate module to prevent hot reload from resetting state

import { ILocale, ILocaleOptions, LocaleID } from './types'

export const DEFAULT_LOCALE_ID: LocaleID = 'en_US'

export const LOCALES: Record<LocaleID, ILocale> = {
  [DEFAULT_LOCALE_ID]: EMPTY_LOCALE(DEFAULT_LOCALE_ID)
}

export const PRELOAD_LOCALES = new Set<LocaleID>()
PRELOAD_LOCALES.add(DEFAULT_LOCALE_ID)

export const LOCALE_DICT_LOADING = new Set<LocaleID>()

export function EMPTY_LOCALE_OPTIONS() {
  const localeOptions: ILocaleOptions = {
    rtl: false
  }
  return localeOptions
}
export function EMPTY_LOCALE(localeID: LocaleID = DEFAULT_LOCALE_ID) {
  const locale: ILocale = {
    id: localeID,
    loaded: false,
    updatedFromServer: false,
    dict: {},
    options: EMPTY_LOCALE_OPTIONS()
  }
  return locale
}

export function ensureLocale(localeID: LocaleID) {
  return LOCALES[localeID] || ((LOCALES[localeID] = EMPTY_LOCALE(localeID)), LOCALES[localeID])
}
